import { Modal, ModalContents } from '@controlrooms/components';

export const ConfirmCloseModal = ({ onConfirm }: { onConfirm: (closeState: boolean) => void }) => {
  return (
    <Modal open={true}>
      <ModalContents
        title={'Confirm to close view'}
        styles={{ content: { minWidth: '450px' } }}
        confirmButtonText="Close View"
        closeButtonText="Cancel"
        closeButtonCallback={() => {
          onConfirm(false);
        }}
        shouldCloseOnEsc={false}
        confirmButtonCallback={async () => {
          onConfirm(true);
        }}
        dataTestIdCancel="modal-close-icon-delete-alert"
      >
        <div style={{ padding: '10px', fontSize: '13px' }}>
          <p>Are you sure you want to close this view?</p>
        </div>
      </ModalContents>
    </Modal>
  );
};
